module.exports = __webpack_public_path__ + "static-m/img/car-t.f3e0ad34.png";